import React, { useState } from "react";
import "../../css/pages/ContactUs.css";
import { useNavigate } from "react-router-dom";
import Button from "../components/buttons/PrimaryButton";
import { ReactComponent as PhoneIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/arrow_up.svg";
// import contactBackground from "../../assets/images/The Plan logo Print.jpg";
import SecondaryButton from "./buttons/SecondaryButton";
import PrimaryButton from "../components/buttons/PrimaryButton";

function ContactUsPage() {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // clear field error as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const next = {};

    if (!form.name.trim()) next.name = "Name is required";
    if (!form.number.trim()) next.number = "Number is required";
    if (!form.email.trim()) next.email = "Email is required";
    if (!form.message.trim()) next.message = "Message is required";
    if (!form.consent)
      next.consent = "Please confirm you have read the privacy policy";

    setErrors(next);
    return Object.keys(next).length === 0;
    };
    
    // console.log("API URL:", process.env.REACT_APP_SERVER_URL);

  /**
   * Runs automatically on Google Form submit (installable trigger).
   * Sends the form response to your Node endpoint.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!validate()) return;

      const to = process.env.REACT_APP_ADVISER_EMAIL;

      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        number: form.number.trim(),
        message: form.message.trim(),
        to: (to || "").trim(),
      };

      const url = `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`;

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errText = await res.text();
        console.log("API error:", errText);
        return;
      }

      // optional: success UI / reset
      setForm({
        name: "",
        number: "",
        email: "",
        message: "",
        consent: false,
      });

      setErrors({});
      console.log("Sent successfully");
    } catch (err) {
      console.log("handleSubmit error:", err);
    }
  };

  return (
    <>
      {/*  CONTACT FORM */}
      <section className="contact-form-wrap" id="contact">
        <div className="contact-us-row">
          <div className="contact-us-info">
            <div className="nav-regular primary">Get started</div>
            <div>
              <h2>One conversation.</h2>
              <h2 className="primary">changes everything.</h2>
            </div>
            <div className="title grey">
              No hard sell. No pressure. Just an honest conversation about where
              you are and where you want to be. Relevant to every rank, every
              role, every stage of service.
            </div>
            <div className="title grey">
              Your information is used solely to arrange your consultation. The
              Plan UK is an FCA regulated financial adviser. Your home may be
              repossessed if you do not keep up repayments on a mortgage. The
              value of investments can go down as well as up.
            </div>
          </div>
          <>
            <form className="contact-form" onSubmit={handleSubmit}>
              {/* <h2>Send Us A Message</h2>
              <div
                className="divider align-center"
                style={{ width: "100%" }}
              ></div> */}
              <div className="contact-row">
                <div className="contact-field">
                  <label className="nav-regular">Name</label>
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className={errors.name ? "has-error" : ""}
                  />
                  {errors.name ? (
                    <span className="error-text">{errors.name}</span>
                  ) : null}
                </div>

                <div className="contact-field">
                  <label className="nav-regular">Phone Number</label>
                  <input
                    name="number"
                    value={form.number}
                    onChange={handleChange}
                    className={errors.number ? "has-error" : ""}
                  />
                  {errors.number ? (
                    <span className="error-text">{errors.number}</span>
                  ) : null}
                </div>
              </div>

              <div className="contact-field">
                <label className="nav-regular">Email</label>
                <input
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className={errors.email ? "has-error" : ""}
                />
                {errors.email ? (
                  <span className="error-text">{errors.email}</span>
                ) : null}
              </div>

              <div className="contact-field">
                <label className="nav-regular">
                  What would you like to talk about?
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows={8}
                  className={errors.message ? "has-error" : ""}
                />
                {errors.message ? (
                  <span className="error-text">{errors.message}</span>
                ) : null}
              </div>

              <div className="contact-consent">
                <input
                  type="checkbox"
                  name="consent"
                  checked={form.consent}
                  onChange={handleChange}
                  id="consent"
                />
                <label htmlFor="consent" className="content">
                  <span style={{ color: "#d04444" }}>*</span>I confirm I have
                  read the{" "}
                  <span
                    // href="/privacy-policy"
                    // target="_blank"
                    // rel="noopener noreferrer"
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    privacy policy
                  </span>
                </label>
              </div>

              <PrimaryButton
                text="Send - let’s talk"
                type="submit"
                // className="contact-submit"
              />
            </form>
            {errors.consent ? (
              <span className="error-text">{errors.consent}</span>
            ) : null}
          </>
        </div>
      </section>
    </>
  );
}

export default ContactUsPage;
